import { createContext, useContext, useState } from 'react';

const T = {
  en: {
    nav: { features: 'Features', shop: 'Shop', reviews: 'Reviews', admin: 'Admin' },
    hero: {
      badge: 'Premium Tweaks',
      title1: 'VANTA',
      title2: 'PERFORMANCE · MACROS',
      subtitle: 'Dominate every match with precision-engineered PC optimizations.',
      cta1: 'Visit Shop',
      cta2: 'Read Reviews',
    },
    features: {
      heading: 'Why Choose Vanta',
      items: [
        { title: 'Instant Access', desc: 'Get immediate access to all tweaks right after purchase. No waiting, no delays.' },
        { title: 'Secure & Tested', desc: 'Every tweak is rigorously tested for safety and performance. Your system is safe.' },
        { title: 'Instant Download', desc: 'Download your files instantly. Fast delivery with lifetime re-downloads.' },
      ],
    },
    shop: {
      heading: 'Choose Your Plan',
      sub: 'Select the plan that fits your needs',
      freeBtn: 'Join Discord',
      buyBtn: 'Buy Now',
    },
    reviews: {
      heading: '70+ Users Trust Vanta',
      sub: 'Join thousands of power users who have optimized their systems.',
    },
    support: 'Support',
    admin: {
      title: 'Admin Panel',
      passLabel: 'Password',
      enterBtn: 'Enter',
      wrongPass: 'Incorrect password',
      logout: 'Logout',
      saveBtn: 'Save Changes',
      saved: 'Saved!',
      productName: 'Display Name',
      productFeatures: 'Features (one per line)',
    },
    payment: {
      checking: 'Verifying payment...',
      success: 'Payment successful!',
      successSub: 'Check your email for download instructions.',
      failed: 'Payment not completed',
      failedSub: 'Your payment was not processed. Please try again.',
      close: 'Close',
      backToShop: 'Back to Shop',
    },
  },
  de: {
    nav: { features: 'Features', shop: 'Shop', reviews: 'Bewertungen', admin: 'Admin' },
    hero: {
      badge: 'Premium Tweaks',
      title1: 'VANTA',
      title2: 'PERFORMANCE · MACROS',
      subtitle: 'Dominiere jedes Match mit präzisions-optimiertem Windows-System.',
      cta1: 'Shop besuchen',
      cta2: 'Bewertungen lesen',
    },
    features: {
      heading: 'Warum Vanta',
      items: [
        { title: 'Sofortiger Zugang', desc: 'Erhalte nach dem Kauf sofort Zugang zu allen Tweaks. Kein Warten.' },
        { title: 'Sicher & Getestet', desc: 'Jeder Tweak wird auf Sicherheit und Performance geprüft.' },
        { title: 'Sofort-Download', desc: 'Lade deine Dateien sofort herunter. Schnelle Lieferung, lebenslange Downloads.' },
      ],
    },
    shop: {
      heading: 'Wähle deinen Plan',
      sub: 'Wähle den Plan, der zu dir passt',
      freeBtn: 'Discord beitreten',
      buyBtn: 'Jetzt kaufen',
    },
    reviews: {
      heading: '70+ Nutzer vertrauen Vanta',
      sub: 'Schließe dich tausenden von Power-Usern an, die ihr System optimiert haben.',
    },
    support: 'Support',
    admin: {
      title: 'Admin-Panel',
      passLabel: 'Passwort',
      enterBtn: 'Einloggen',
      wrongPass: 'Falsches Passwort',
      logout: 'Ausloggen',
      saveBtn: 'Speichern',
      saved: 'Gespeichert!',
      productName: 'Anzeigename',
      productFeatures: 'Features (eine pro Zeile)',
    },
    payment: {
      checking: 'Zahlung wird geprüft...',
      success: 'Zahlung erfolgreich!',
      successSub: 'Prüfe deine E-Mail für die Download-Anleitung.',
      failed: 'Zahlung nicht abgeschlossen',
      failedSub: 'Deine Zahlung wurde nicht verarbeitet. Bitte versuche es erneut.',
      close: 'Schließen',
      backToShop: 'Zurück zum Shop',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('en');
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: T[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
export default LanguageContext;
